export default __webpack_public_path__ + "static/media/upgrade-icon-1.4a2d34cb.png";